// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  dmm: (t, data?, options?) => t('enum.auth-provider.dmm.name', data, options),
  dmm_staging: (t, data?, options?) => t('enum.auth-provider.dmm-staging.name', data, options),
  dmm_test: (t, data?, options?) => t('enum.auth-provider.dmm-test.name', data, options),
  facebook: (t, data?, options?) => t('enum.auth-provider.facebook.name', data, options),
  password: (t, data?, options?) => t('enum.auth-provider.password.name', data, options),
  /* eslint-enable max-len */
};
